/**
 * 消息事件类
 */
export namespace MessageEventKind {
    
    /** 事件 */  
    export enum EventName {
    	/** 更新抽奖列表 */
        UPDATE_LOTTERY_LIST = 'UPDATE_LOTTERY_LIST',
        /** 更新经验 */
        UPDATE_EXP = 'UPDATE_EXP',
        /** 更新等级 */
        UPDATE_LEVEL = 'UPDATE_LEVEL',
        /** 提升等级 */
        PROMOTE_LEVEL = 'PROMOTE_LEVEL',
        /** 显示城池 */
        SHOW_MILITARY_MAP = 'SHOW_MILITARY_MAP',
        /** 夸贵妃提示 */
        BOAST_GUI_FEI_HINT = 'BOAST_GUI_FEI_HINT',
        /** 等级判断 */
        LEVEL_JUDGE = 'LEVEL_JUDGE',
        /** 更新丘比特之屋状态 */
        UPDATE_CUPID_HOUSE_STATE = 'UPDATE_CUPID_HOUSE_STATE',
        /** 刷新特殊按钮状态 */
        REFRESH_SPECIAL_BTN_STATE = 'REFRESH_SPECIAL_BTN_STATE',

        /** 更新城池丢失状态 */
        REFRESH_CITY_DROP_STATE = 'REFRESH_CITY_DROP_STATE',
        /** 收到女娲石 */
        REFRESH_NVWA_STORE_COLLECT = 'REFRESH_NVWA_STORE_COLLECT',
        /** 收集女娲石 */
        NVWA_STORE_COLLECT_ANI = 'NVWA_STORE_COLLECT_ANI',
        /** 收集藏宝图 */
        TREASURE_MAP_COLLECT_ANI = 'TREASURE_MAP_COLLECT_ANI',
        /** 收集藏宝图 */
        REFERSH_TREASURE_MAP_COLLECT = 'REFERSH_TREASURE_MAP_COLLECT',
        /** 更换装备 */
        MATCH_MIAI_SWITCH_EQUIP = 'MATCH_MIAI_SWITCH_EQUIP',
        /** 招亲第二关 */
        START_MATCH_MIAI_SECOND_LEVEL = 'START_MATCH_MIAI_SECOND_LEVEL',
        /** 刷新任务 */
        REFRESH_TASK_STATE = 'REFRESH_TASK_STATE',
        /** 广告卡 */
        REFRESH_AD_CARD_COUNT = 'REFRESH_AD_CARD_COUNT',
        /** 考古 */
        GAME_KAOGUDATA = 'game-kaoguData',
        /** 油田 */
        GAME_OILFIELD_DATA = 'game-oilfieldData',
        /** 考古收集 */
        REFRESH_KAOKU_COLLECT_STATE = 'REFRESH_KAOKU_COLLECT_STATE',
        /** 油田收集 */
        REFRESH_OilField_COLLECT_STATE = 'REFRESH_OilField_COLLECT_STATE',
        /** 五彩果收集 */
        REFRESH_ORCHARD_COLLECT_STATE = 'REFRESH_ORCHARD_COLLECT_STATE',
        /** 油田收集完成 */
        REFRESH_OilField_COLLECT_Finish = 'REFRESH_OilField_COLLECT_Finish',
        /** 打劫匪复活次数 */
        REFRESH_HIT_ROB_REVIVE_COUNT = 'REFRESH_HIT_ROB_REVIVE_COUNT',
        /** 刷新府邸成员每日数据 */
        REFRESH_MAINSION_MEMBER_DATA = 'REFRESH_MAINSION_MEMBER_DATA',
        /** 进入关卡 */
        ENTER_THRU_TIME_LEVEL = 'ENTER_THRU_TIME_LEVEL',
        /**选妃开始打乱顺序 */
        SELECT_CONCUBINE_RANDSORT = 'SELECT_CONCUBINE_RANDSORT',
        /**退出选妃 */
        CLOSE_CONCUBINE = 'CLOSE_CONCIBLNE',
        /** 关闭选妃揭盖头 */
        CLOSE_SELECT_CONCUBINE = 'CLOSE_SELECT_CONCUBINE',
        /**选妃改变暂停状态 */
        SELECT_CONCUBINE_PAUSE_STATUS = 'SELECT_CONCUBINE_PAUSE_STATUS',
    }

}